var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayeredWavesHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#001220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 438L30 425.5C60 413 120 388 180 379.7C240 371.3 300 379.7 360 393.8C420 408 480 428 540 433.2C600 438.3 660 428.7 720 428.2C780 427.7 840 436.3 870 440.7L900 445L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z",
    fill: "#fa7268"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 457L30 450.7C60 444.3 120 431.7 180 430.8C240 430 300 441 360 447.8C420 454.7 480 457.3 540 456.8C600 456.3 660 452.7 720 445C780 437.3 840 425.7 870 419.8L900 414L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z",
    fill: "#f36567"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 460L30 460.3C60 460.7 120 461.3 180 457.3C240 453.3 300 444.7 360 447.7C420 450.7 480 465.3 540 476.8C600 488.3 660 496.7 720 496.7C780 496.7 840 488.3 870 484.2L900 480L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z",
    fill: "#eb5967"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 479L30 477.5C60 476 120 473 180 476.2C240 479.3 300 488.7 360 497.8C420 507 480 516 540 509.5C600 503 660 481 720 478.7C780 476.3 840 493.7 870 502.3L900 511L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z",
    fill: "#e34c67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 531L30 528.3C60 525.7 120 520.3 180 515.2C240 510 300 505 360 506C420 507 480 514 540 519.8C600 525.7 660 530.3 720 528.7C780 527 840 519 870 515L900 511L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z",
    fill: "#da3f67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 550L30 551.8C60 553.7 120 557.3 180 554.8C240 552.3 300 543.7 360 540.2C420 536.7 480 538.3 540 540C600 541.7 660 543.3 720 542.3C780 541.3 840 537.7 870 535.8L900 534L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z",
    fill: "#d03267"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 552L30 555.7C60 559.3 120 566.7 180 566.7C240 566.7 300 559.3 360 554.8C420 550.3 480 548.7 540 553C600 557.3 660 567.7 720 572.7C780 577.7 840 577.3 870 577.2L900 577L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z",
    fill: "#c62368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredWavesHaikei);
export default __webpack_public_path__ + "static/media/layered-waves-haikei.326c6fe28ba8932aa0ecdcc9b9ae2045.svg";
export { ForwardRef as ReactComponent };